import { PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";

import { ErrorBoundaryFallback } from "./ErrorBoundaryFallback";

/**
 * Error boundary that resets when the route changes, so the browser Back
 * button or a new URL recovers from an error. Must be rendered inside a Router.
 */
export const RouteErrorBoundary = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorBoundaryFallback}
      resetKeys={[pathname]}
    >
      {children}
    </ErrorBoundary>
  );
};
